import { Action, createReducer, on } from '@ngrx/store';
import { VoucherState } from './voucher.state';
import {
  getVoucherAction,
  getVoucherErrorAction,
  getVoucherSuccessAction,
  setLoyaltyVouchersToApplyAction,
  setVoucherAutoApplyAction,
  setVoucherAutoApplyErrorAction,
  setVoucherAutoApplySuccessAction,
} from './voucher.actions';

const initialState = new VoucherState();

const reducer = createReducer(
  initialState,
  on(getVoucherAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(getVoucherSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.voucher = payload.voucher;
    return newState;
  }),
  on(getVoucherErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(setVoucherAutoApplyAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(setVoucherAutoApplySuccessAction, (state) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.voucherAutoApplyResponse = { data: true };
    return newState;
  }),
  on(setVoucherAutoApplyErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  }),
  on(setLoyaltyVouchersToApplyAction, (state, payload) => {
    const newState = { ...state };
    newState.loyaltyVouchersToApply = payload.loyaltyVouchersToApply;
    newState.isLoading = false;
    return newState;
  })
);

export function VoucherReducer(state: VoucherState | null, action: Action) {
  return reducer(state, action);
}
